/**
 * Класс для преобразования координат виджета выделения в абсолютные координаты самого изображения
 */
export class Coords {
    public x: number;
    public y: number;
    public width: number;
    public height: number;

    constructor(
        private previewWidth: number = 843,
    ) {}

    /**
     * Преобразовать относительные координаты в абсолютные
     * @param img
     * @param coords
     */
    setCoordsAsAbsolute(img: HTMLImageElement, coords: JcropCoordsInterface) {
        const scale = this.getScale(img);
        this.x = coords.x * scale;
        this.y = coords.y * scale;
        this.width = coords.w * scale;
        this.height = coords.h * scale;
    }

    setPreviewWidth(width: number) {
        this.previewWidth = isNaN(width) ? 843 : width;
    }

    /**
     * Порлучить масштаб, нсколько реальное изображение больше виджета
     * @param img
     */
    private getScale(img: HTMLImageElement): number {
        const naturalWidth = img.naturalWidth;

        if (naturalWidth <= this.previewWidth) {
            return 1;
        } else {
            return naturalWidth / this.previewWidth;
        }
    }
}

interface JcropCoordsInterface {
    w: number;
    h: number;
    x: number;
    y: number;
}
